import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseConsultaPedido } from '../model/ResponseConsultaPedido';

@Injectable({
  providedIn: 'root'
})
export class ConsultaService {
  private urlApi = environment.rootUrlApi + 'pedido';

  constructor(private http: HttpClient) { }

  public loginConsultaPedidosResponsavel(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/loginResponsavel', dados);
  }

  public consultaPedidoResponsavel(dados: {cpf: string}, token: string): Observable<ResponseConsultaPedido> {
    const headers = {'Authorization': `Bearer ${token}`};
    return this.http.post<ResponseConsultaPedido>(this.urlApi + '/consultaPedidoResponsavel', dados, { headers });
  }
}
